<pre class="smart-log-tail-content">
    <span *ngFor="let line of smartLogTail.lines; let i = index;"
        ng-class="{'text-error':  smartLogTail.status[i] == TAIL_STATUS.ERROR, 'text-warning': smartLogTail.status[i] == TAIL_STATUS.WARNING, 'text-success': smartLogTail.status[i] == TAIL_STATUS.SUCCESS}">
        {{line}}
    </span>
</pre>
